import React, { Component } from 'react';
import { Container, Col, Row } from 'react-grid-system';
import PropTypes from 'prop-types';
import { forceCheck } from 'react-lazyload';
import ConfigManager from '../../../common/configManager/configManager';
import CompetitionTable from './CompetitionTable';
import HeaderTable from '../../../components/HeaderTable';
import { liveCompetitionsCounter } from '../../../utils/sports';
class SportTable extends Component {

  constructor(props) {
    super(props);
    this.isGazzetta = process.env.REACT_APP_SITE === 'gazzetta';
  }

  componentDidMount() {
    const interval = ConfigManager.getSportRefreshInterval(this.props.sportId) ? ConfigManager.getSportRefreshInterval(this.props.sportId) : 60000;
    if (this.props.filterDate.get('value') === 'today') {
      this.sportTimer = setInterval(this.updateTableData, interval);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Se cambia la data e non è "today", pulisci il timer
    if (this.props.filterDate.get('value') !== nextProps.filterDate.get('value') && nextProps.filterDate.get('value') !== 'today') {
      if (this.sportTimer) {
        clearInterval(this.sportTimer);
        const loadF1 = new Event('loadFrame1MC', { bubbles: true });
        document.dispatchEvent(loadF1);
      }
      return;
    }
  
    // Se siamo in "today"
    if (nextProps.filterDate.get('value') === 'today') {
      const interval = nextProps.sportId === "1" && nextProps.liveSoccerMatches > 0 && this.isGazzetta
      ? 1000 
      : ConfigManager.getSportRefreshInterval(nextProps.sportId) || 60000;
      // Se il timer esiste già, viene aggiornato solo se necessario
      if (this.sportTimer) {
        // Se cambia il numero di partite live nel calcio o lo sport, aggiorna l'intervallo
        if ((nextProps.sportId === "1" && nextProps.liveSoccerMatches !== this.props.liveSoccerMatches) ||
            nextProps.sportId !== this.props.sportId) {
          clearInterval(this.sportTimer);
          this.sportTimer = setInterval(this.updateTableData, interval);
        }
      } else {
        // Crea il timer se non è stato mai istanziato
        this.sportTimer = setInterval(this.updateTableData, interval);
      }
    }
  }

  componentDidUpdate() {
    forceCheck();
  }

  componentWillUnmount() {
    if (this.sportTimer) {
      clearInterval(this.sportTimer);
    }
  }

  updateTableData = () => {
    this.props.actions.getCompetitionsList(this.props.filterDate, this.props.sportId, this.props.filterLive, process.env.REACT_APP_SITE);
  };

  switchCompetitionTable = (currentCompetition, index) => {
    const {
      sportName,
      actions,
      dictionary,
      sportId,
      isMobile,
      filterDate,
    } = this.props;

    switch (sportId) {
      case '6C':
      case '6M':
        return (
          <CompetitionTable
            actions={actions}
            showRowScorer={false}
            competition={currentCompetition}
            sportName={sportName}
            key={index}
            dictionary={dictionary}
            sportId={sportId}
            isMobile={isMobile}
            date={filterDate.get('value')}
            isRace
          />
        );
      default:
        return (
          <CompetitionTable
            actions={actions}
            showRowScorer={false}
            competition={currentCompetition}
            sportName={sportName}
            key={index}
            dictionary={dictionary}
            sportId={sportId}
            isMobile={isMobile}
            date={filterDate.get('value')}
          />
        );
    }
  };

  render() {
    const { competitions, sportName } = this.props;

    return (
      <React.Fragment>
        <Container className="sportTableLive" fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
          {competitions && competitions.size !== 0 && sportName && (process.env.REACT_APP_SITE !== 'fcinter' && process.env.REACT_APP_SITE !== 'calcionapoli1926' && process.env.REACT_APP_SITE !== 'forzaroma') &&
            <Row style={{ marginLeft: 0, marginRight: 0 }}>
              <Col md={12} sm={12} xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <HeaderTable
                  title={sportName}
                  bgColor="mainColorDark"
                />
              </Col>
            </Row>
          }

          {
            competitions && competitions.size > 0 && competitions.map((currentCompetition, index) => (
              currentCompetition &&
              currentCompetition.get('competitionMatches') &&
              currentCompetition.get('competitionMatches').size > 0 &&
              <Row key={index} style={{ margin: '0px' }}>
                <Col md={12} sm={12} xs={12} style={{ padding: '0px' }}>
                  {this.switchCompetitionTable(currentCompetition, index)}
                </Col>
              </Row>
            ))
          }
        </Container>
      </React.Fragment>

    );
  }
}

SportTable.propTypes = {
  dictionary: PropTypes.any,
  competitions: PropTypes.any,
  sportName: PropTypes.any,
  actions: PropTypes.any,
  filterLive: PropTypes.any,
  sportId: PropTypes.any,
  isMobile: PropTypes.any,
  filterDate: PropTypes.any,
  firstAvailable: PropTypes.any,
};

export default SportTable;
